module.exports = __webpack_public_path__ + "media/4.f8275071.mp3";